import type { Row } from '@tanstack/react-table';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import type { AssignmentListRowData } from './types';

export function CardWorkAssignments({
  row,
}: {
  row: Row<AssignmentListRowData>;
}) {
  return (
    <Card className="tw:bg-transparent" size="sm">
      <CardHeader>
        <CardTitle>6. Work Assignments</CardTitle>
      </CardHeader>
      <CardContent className="tw:grid tw:gap-2">
        <p className="tw:mb-0! tw:text-xs">
          Work assignments are shared with the ICS-215. Changes here appear
          there as well.
        </p>
        <Button
          variant="outline"
          size="sm"
          className="tw:w-fit tw:hidden"
          disabled
        >
          <Plus /> Add Work Assignment
        </Button>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Overhead Position</TableHead>
              <TableHead>Special Instructions</TableHead>
              <TableHead>Reporting Location</TableHead>
              <TableHead>Date / Time</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {row.original.workAssignments.length ? (
              row.original.workAssignments.map((workAssignment) => (
                <TableRow key={workAssignment.id}>
                  <TableCell>{workAssignment.name}</TableCell>
                  <TableCell>{workAssignment.overheadPosition}</TableCell>
                  <TableCell>{workAssignment.specialInstructions}</TableCell>
                  <TableCell>{workAssignment.reportingLocation}</TableCell>
                  <TableCell>{workAssignment.timestamp}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5}>No work assignments</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
}
